import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { clearAuth, getToken, getUser } from "../config/auth";

const getNormalizedRole = () => String(getUser()?.role || "STUDENT").toUpperCase();

export function RequireAuth() {
  const location = useLocation();
  const token = getToken();
  const user = getUser();

  if (!token || !user) {
    clearAuth();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (getNormalizedRole() === "ADMIN" && location.pathname === "/dashboard") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
}

export function RequireAdminAuth() {
  const location = useLocation();
  const token = getToken();
  const user = getUser();

  if (!token || !user) {
    clearAuth();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (getNormalizedRole() !== "ADMIN") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
